<template>
  <v-container grid-list-xl>
    <v-slide-y-transition mode="out-in">
      <v-layout column>
        <help-button>
          <h2>Playing the Game: </h2>
            <p>
              1. Enter the "Learn" section to start studying the next lesson. You will be presented with a short primer on the lesson content, followed by a list of vocabulary that you will encounter and master during the lesson.
            </p>
            <p>
              2. Enter the "Play" section to answer review questions that will count toward your progression in the game.
            </p>
        </help-button>
        <!-- Onboarding Card -->
        <v-flex v-show="onboard1" xs12>
          <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3" color="secondary">
            <v-card-actions>
              <v-card-text style="color: white;">
                In the <b>"Learn"</b> module, each lesson begins with a short article on grammar.
                Then, you will study the set of vocabulary associated with that lesson.
              </v-card-text>
            </v-card-actions>
            <div class="pa-1 ma-1">
              <v-card class="elevation-1 pa-1" max-width="90%" style="margin: auto;">
                <v-card-title primary-title class="headline">
                  leannán
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  lover
                </v-card-text>
                <v-card-actions>
                  <v-btn flat color="primary">
                    Add To Reviews
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
            <v-card-actions>
              <v-card-text style="color: white;">
                After finishing the lessons in the <b>"Learn"</b> section, return to the Dashboard,
                and proceed to the <b>"Play"</b> section to review what you've learned.
                </v-card-text>
            </v-card-actions>
            <v-layout align-center justify-center column>
                <v-btn
                  large
                  round
                  outline
                  align-center
                  justify-center
                  style="color:white;"
                  @click="onboard1 = $store.state.user.onboarding1 = false">
                  Okay
                </v-btn>
              </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <!-- Lesson Card -->
          <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3">
            <div style="font-size: 27px; font-weight: bold" color="primary">
              <span>&nbsp;</span>
              <v-icon color="primary" size="30px">school</v-icon>
              <span>Learn</span>
            </div>
            <v-divider></v-divider>

            <v-card-actions>
              <v-card-text v-if="lessonAvailable">
                Take a brief, self-guided tutorial before beginning the game.
              </v-card-text>
              <v-card-text v-else
                >You are all caught up with lessons, enjoy!</v-card-text
              >
            </v-card-actions>
            <v-btn
              v-if="lessonAvailable"
              large
              round
              outline
              color="primary"
              :to="{ name: 'Lesson' }"
              >Start</v-btn
            >
          </v-card>
        </v-flex>

        <!-- Onboarding Card -->
        <v-flex v-show="onboard2" xs12>
          <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3" color="secondary">
            <v-card-actions>
              <v-card-text style="color: white;">
                In the <b>"Play"</b> module, you will go through several different encounters with the vocabulary set from the <b>"Learn"</b> section above.
                After successfully reviewing each term three times, the next lesson will appear in the Dashboard.
              </v-card-text>
            </v-card-actions>
            <v-layout align-center justify-center column>
                <v-btn
                  large
                  round
                  outline
                  align-center
                  justify-center
                  style="color:white;"
                  @click="onboard2 = $store.state.user.onboarding2 = false">
                  Okay
                </v-btn>
              </v-layout>
          </v-card>
        </v-flex>

        <!-- Reviews Card -->
        <v-flex xs12>
          <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3">
            <div style="font-size: 27px; font-weight: bold" color="primary">
              <span>&nbsp;</span>
              <v-icon color="primary" size="30px">assignment_turned_in</v-icon>
              <span>Play</span>
            </div>
            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                v-if="activeItems.length > 0"
                large
                block
                round
                outline
                color="primary"
                :to="{ name: 'Quiz' }"
                >Start</v-btn
              >
              <v-card-text v-else
                >You are all caught up with review games, enjoy! :)</v-card-text
              >
              <v-card-text v-if="activeItems.length > 0">
                There are {{ activeItems.length }} questions left!
              </v-card-text>
              <v-card-text v-if="nextReviewTime">
                <i>Next review {{ nextReviewTime }}.</i>
              </v-card-text>
            </v-card-actions>
          </v-card>
        </v-flex>

      <!-- Onboarding Card -->
        <v-flex v-show="onboard3" xs12>
          <v-card min-height="170px" class="rounded-card elevation-3 pa-3 ma-3" color="secondary">
            <v-card-actions>
              <v-card-text style="color: white;">
                This app utilizes a spaced repeition learning technique that adjusts the time between each review so that your recall is tested at
                the most ideal time for your memory. The better you know an item, the longer it will be until it comes up again for review. 
                If you keep getting something wrong, the time between reviews will decrease, meaning you will see it more often.
                You can view your progress in the <b>"Progress"</b> module below!
              </v-card-text>
            </v-card-actions>
              <v-layout align-center justify-center column>
                <v-btn
                  large
                  round
                  outline
                  align-center
                  justify-center
                  style="color:white;"
                  @click="onboard3 = $store.state.user.onboarding3 = false">
                  Okay
                </v-btn>
              </v-layout>
          </v-card>
        </v-flex>

        <!-- Progress Card -->
        <v-flex xs12>
          <v-card height="170px" class="rounded-card elevation-3 pa-3 ma-3">
            <div style="font-size: 27px; font-weight: bold" color="primary">
              <span>&nbsp;</span>
              <v-icon color="primary" size="30px">show_chart</v-icon>
              <span>Progress: {{ percent | percent }}</span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center column>
              <v-card width="80%" flat>
                <v-progress-linear v-model="percent"></v-progress-linear>
              </v-card>
              <div>
                <v-btn large block round outline color="primary" to="/Progress">
                  View Progress
                </v-btn>
              </div>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { store } from "../store/store.js";
import { mapGetters, mapState } from "vuex";
import * as moment from "moment";
import { MAX_SRS, SRS_BASE_INTERVAL } from "@/constants.js";
import HelpButton from "../components/HelpButton.vue";
const wordMaxedOut = function (word) {
  return word.srs >= MAX_SRS;
};

const sortSRSTrackersByLastChange = function compare(a, b) {
  if (a.lastChange < b.lastChange) {
    return -1;
  } else if (a.lastChange > b.lastChange) {
    return 1;
  } else return 0;
};

const wordAvailable = function (word) {
  return Date.now() > wordAvailableTime(word);
};
const wordActive = function (word) {
  return !wordMaxedOut(word) && wordAvailable(word);
};
const wordAvailableTime = function (word) {
  return word.lastChange + word.srs * SRS_BASE_INTERVAL;
};

export default {
  components: { HelpButton },
  created() {
    this.time = setInterval(this.update, 1000);
  },
  destroyed() {
    clearInterval(this.time);
  },
  data() {
    return {
      progress: 50,
      nextReviewTime: 0,
      time: null,
      activeQuestions: [],
      onboard1: this.$store.state.user.onboarding1,
      onboard2: this.$store.state.user.onboarding2,
      onboard3: this.$store.state.user.onboarding3
    };
  },
  methods: {
    update: function () {
      this.nextReviewTime = this.getNextReviewTime();
    },
    getNextReviewTime: function () {
      if (this.activeItems.length > 0) return "is available now";
      else {
        var nextReview = this.$store.state.queue
          .filter((wt) => !wordMaxedOut(wt))
          .sort(sortSRSTrackersByLastChange)[0];
        if (nextReview) {
          // if the diff between time for next review and current time is positive, display countdown
          if (moment(wordAvailableTime(nextReview)).diff(moment()) > 0) {
            return moment(wordAvailableTime(nextReview)).fromNow();
          } else {
            return "is available now";
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "reviews",
      "reviewsAvailable",
      "unstudiedVocab",
      "loading",
      "error",
      "currentLesson",
      "activeItems",
    ]),
    lessonAvailable: function () {
      return (
        !this.$store.state.user.lessonReviewed ||
        this.$store.getters.unstudiedVocab.length > 0
      );
    },
    lessonsNumber: function () {
      return this.$store.getters.unstudiedVocab.length;
    },
    percent: function () {
      return this.$store.getters.progress;
    },
    // currentLesson: function() {
    //   console.log(this.$store.getters.currentLesson);
    //   return 1;
    // }
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
box {
  top: 20px;
}
.rounded-card {
  border-radius: 10px;
  max-width: 800px;
  margin: auto !important;
}
v-btn {
  max-width: 100px;
}
</style>
